// Screen `blueprint-upgrade` — design/screens/BlueprintUpgrade.dc.html — owner: S9.
import { createFileRoute } from '@tanstack/react-router';
import { UpgradePage } from '../../../../../features/blueprints/UpgradePage';

export const Route = createFileRoute('/_settings/settings/blueprints/$key/upgrade')({
  component: BlueprintUpgradeRoute,
});

function BlueprintUpgradeRoute() {
  const { key } = Route.useParams();
  return <UpgradePage key={key} blueprintKey={key} />;
}
